module.exports = __webpack_public_path__ + "7e6245dd49d56a8d49d6ae57553cbf21.png";